var _excluded = ["disabled", "className", "variant", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
var AgroIconButton = withCssProps(function (_ref) {
  var disabled = _ref.disabled,
    className = _ref.className,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    className: className,
    variant: variant,
    disabled: disabled,
    type: "button"
  }, props), children);
});
AgroIconButton.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'secondary', 'default'])
};
AgroIconButton.displayName = 'AgroIconButton';
export { AgroIconButton };
var IconButton = styled.button.withConfig({
  displayName: "AgroIconButton__IconButton",
  componentId: "sc-6r2lt7-0"
})(["all:unset;border-radius:24px;padding:12px;max-height:24px;cursor:pointer;transition:all 0.2s ease-in;", " ", " ", " ", ""], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["pointer-events:none;opacity:0.5;"]);
}, function (_ref3) {
  var variant = _ref3.variant;
  return variant === 'default' && css(["padding:0px;max-height:32px;svg{&:hover:not(:disabled){opacity:0.9;}}"]);
}, function (_ref4) {
  var variant = _ref4.variant;
  return variant === 'primary' && css(["&:hover:not(:disabled){background-color:rgb(20,28,39,0.05);}"]);
}, function (_ref5) {
  var variant = _ref5.variant;
  return variant === 'secondary' && css(["background:#ffffff;border:1px solid ", ";box-shadow:0px 1px 2px rgba(0,0,0,0.1);padding:11px;&:hover{border:1.00048px solid ", ";box-shadow:0px 6px 10px rgba(0,0,0,0.15);}&:hover svg path{transition:all 0.2s ease-in;fill:", ";}"], function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.gray100;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.colors.gray100;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.green500;
  });
});